import React, { Component } from 'react'
import styled from 'styled-components'
import { lighten } from 'polished'
import Icon from 'app/components/Icon'
import t from 'app/lib/i18n'
import colors from 'app/lib/colors'
import { filterRestrictionsFromString } from 'app/lib/util'
import D2CCard from 'app/components/D2CCard'
import changeIcon from './change.svg'

const Wrap = styled.div`
  box-sizing: border-box;
  padding: 20px;
  width: auto;
  display: flex;

  .table {
    flex: 1;
    width: 100%;
    border-collapse: collapse;
  }

  .section {
    vertical-align: middle;
    margin: 5px 20px;

    td {
      border-top: 1px ${colors.lightGray} solid;
      width: 90%;
    }

    .label-area {
      display: flex;
      flex-direction: column;
      align-info: flex-start;
      justify-content: flex-start;
      padding-bottom: 5px;
    }

    .label-text {
      white-space: nowrap;
      font-size: 12px;
      line-height: 2.6;
      letter-spacing: 0.4px;
      color: ${colors.darkGray};
    }

    .info {
      flex: 1;
      font-size: 14px;
      line-height: 1.3;
      color: ${colors.darkGray};
      padding: 8px;
    }

    .icon {
      font-size: 20px;
      margin-top: -4px;
      margin-left: 2px;
      margin-bottom: 3px;
    }
  }
`

const D2CWrap = styled(Wrap)`
  padding: 0 24px 10px;

  .section td {
    border-color: ${props => colors.hexToRgb(props.theme.primary, 0.2)};
  }

  .section:first-child td {
    border-top: none;
  }
`

const TextIcon = styled.div`
  display: inline-block;
  margin-top: -8px;
  font-size: 25px;
  font-weight: bold;
  color: ${props => props.color}
  text-align: center;
  width: 23px;
`

export default class FoodGroupInfo extends Component {
  renderSection(label, iconText, iconColor, info, iconName = null) {
    if (info && info.length > 0) {
      return (
        <tr className="section">
          <td className="label-area">
            <div className="label-text">{t(label)}</div>
            {iconName ? (
              <Icon name={iconName} color={iconColor} className="icon" />
            ) : (
              <TextIcon color={iconColor}>{iconText}</TextIcon>
            )}
          </td>
          <td className="info">{info}</td>
        </tr>
      )
    }
  }

  render() {
    let included = this.props.food_groups_included
    let lacking = this.props.food_groups_lacking
    let includesTitle = this.props.includesTitle
    let lacksTitle = this.props.lacksTitle
    let goals = this.props.goals
    let goalsText = null
    let dietRestrictions = this.props.diet_restrictions
    let limits = this.props.limits

    if (goals && goals.length > 0) {
      let glist = goals.map(g => t(g.standalone_label || g.label))
      glist = [glist.slice(0, -1).join(', '), glist.slice(-1)[0]].join(glist.length < 2 ? '' : ' and ')
      goalsText = glist
    }

    const content = (
      <table className="table">
        <tbody>
          {goals && goals.length > 0 ? this.renderSection('Goals', null, colors.black, goalsText, 'bullseye') : null}
          {included && included.length > 0
            ? this.renderSection(
                includesTitle,
                '+',
                this.props.highlightColor,
                filterRestrictionsFromString(included, dietRestrictions || [])
              )
            : null}
          {limits && limits.length > 0
            ? this.renderSection(
                'Limits',
                '~',
                lighten(0.3, this.props.highlightColor),
                filterRestrictionsFromString(limits, dietRestrictions || []),
                null
              )
            : null}
          {lacking && lacking.length > 0
            ? this.renderSection(
                lacksTitle,
                '\u2014',
                colors.black,
                filterRestrictionsFromString(lacking, dietRestrictions || [])
              )
            : null}
          {dietRestrictions && dietRestrictions.length > 0
            ? this.renderSection(
                'Dietary Restrictions',
                null,
                colors.black,
                dietRestrictions.map(r => t(r.replace(/Free/g, ' Free'))).join(', '),
                null
              )
            : null}
        </tbody>
      </table>
    )

    if (this.props.d2c) {
      return (
        <D2CCard icon={changeIcon} header={t(this.props.header || 'Make these food swaps')}>
          <D2CWrap>{content}</D2CWrap>
        </D2CCard>
      )
    }

    return <Wrap style={this.props.style}>{content}</Wrap>
  }
}
